<template lang="html">
  <div class="order-search-form-wrapper">
    <el-radio-group
      v-model="ruleForm.orderType"
      class="radio-group-wrapper"
      @change="doReset"
    >
<!--      <el-radio-button :label="1">新订单</el-radio-button>-->
<!--      <el-radio-button :label="2">旧订单</el-radio-button>-->
    </el-radio-group>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width=""
      class="order-search-form"
    >
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="" prop="orderNo">
            <el-input
              v-model="ruleForm.orderNo"
              type="text"
              placeholder="订单号、车号、货物名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="" prop="createTime">
            <el-date-picker
              v-model="ruleForm.createTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="timestamp"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="11">
              <el-form-item label="" prop="totalWeightRange.start">
                <el-input
                  v-model="ruleForm.totalWeightRange.start"
                  type="number"
                  placeholder="最小吨位"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="join-line-wrap">
              <span class="join-line">--</span>
            </el-col>
            <el-col :span="11">
              <el-form-item label="" prop="totalWeightRange.end">
                <el-input
                  v-model="ruleForm.totalWeightRange.end"
                  type="number"
                  placeholder="最大吨位"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-button type="default" @click="doReset">重置</el-button>
          <el-button type="primary" @click="doSearch">搜索</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="" prop="startPoint">
            <el-input
              v-model="ruleForm.startPoint"
              type="text"
              placeholder="起点"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" class="join-line-wrap">
          <span class="join-line">--</span>
        </el-col>
        <el-col :span="5">
          <el-form-item label="" prop="endPoint">
            <el-input
              v-model="ruleForm.endPoint"
              type="text"
              placeholder="终点"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      options: [
        {
          label: "运费",
          value: 1
        },
        {
          label: "其他",
          value: 2
        }
      ]
    };
  },
  computed: {},
  created() {},
  methods: {
    doReset() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.activeName = "0";
      this.$emit("search");
    },
    doSearch() {
      this.$emit("search");
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.order-search-form-wrapper {
  .radio-group-wrapper {
    margin-top: 20px;
  }
  .order-search-form {
    margin-top: 20px;
    .join-line-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/order/components/searchForm/index.vue